import React from 'react';
import CustomerLogo from '../CampaignLogo/CampaignLogo';
import CustomerLogoImage from '@core/assets/images/logo-brand-customer.svg';
import FooterMenu from '../Navigation/FooterMenu/FooterMenu';
import classes from './Footer.module.scss';
import { useFooterConfig, formatCSSValue } from '../../stores/index.js';
import { Row, Col } from 'reactstrap';

const FooterContent = (props) => {
    const { logoUrl: customCustomerLogoUrl } = useFooterConfig();
    const customerLogoSrc = customCustomerLogoUrl || CustomerLogoImage;

    return (
        <Row className={classes.Footer}>
            <Col lg="3" className="d-flex align-items-center order-last order-lg-first">
                <CustomerLogo linkUrl={process.env.REACT_APP_CUSTOMER_URL} src={customerLogoSrc} />
            </Col>

            <Col
                lg="9"
                className="d-flex align-items-center justify-content-lg-end justify-content-start order-first order-lg-last"
            >
                <FooterMenu
                    secondaryNavigation={props.secondaryNavigation}
                    consentCookieName={props.consentCookieName}
                />
            </Col>
        </Row>
    );
};

const Footer = (props) => {
    const {
        backgroundColor: footerBackgroundColor,
        padding: { vertical: paddingVertical, horizontal: paddingHorizontal } = {},
        gap: { desktop: gapValueDesktop, mobile: gapValueMobile } = {},
    } = useFooterConfig();

    const isFocusDesktop = Boolean(props.isFocusModeDesktop);
    const isFocusMobile = Boolean(props.isFocusModeMobile);

    if (isFocusDesktop && isFocusMobile) {
        return null;
    }

    const focusClass = isFocusDesktop ? 'd-lg-none' : isFocusMobile ? 'd-none d-lg-block' : '';

    const footerStyle = {};
    if (footerBackgroundColor) {
        footerStyle.backgroundColor = footerBackgroundColor;
    }
    if (paddingVertical) {
        footerStyle.paddingTop = paddingVertical;
        footerStyle.paddingBottom = paddingVertical;
    }
    if (gapValueDesktop !== undefined) {
        footerStyle['--footer-margin-top-desktop'] = formatCSSValue(gapValueDesktop);
    }
    if (gapValueMobile !== undefined) {
        footerStyle['--footer-margin-top-mobile'] = formatCSSValue(gapValueMobile);
    }

    const hasHorizontalPadding =
        paddingHorizontal !== undefined && paddingHorizontal !== null && paddingHorizontal !== '';

    if (hasHorizontalPadding) {
        footerStyle.overflow = 'hidden'; // Prevent row negative margins from causing horizontal scrollbars when padding is small/0
    }

    const containerStyle = {};
    if (hasHorizontalPadding) {
        containerStyle.paddingLeft = paddingHorizontal;
        containerStyle.paddingRight = paddingHorizontal;
    }

    return (
        <footer className={`${classes.FooterWrapper} ${focusClass}`.trim()} style={footerStyle}>
            <div
                className={props.contained ? 'container' : `container-fluid ${hasHorizontalPadding ? '' : 'px-3'}`}
                style={containerStyle}
            >
                <FooterContent {...props} />
            </div>
        </footer>
    );
};

export default Footer;
